var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaLogoRFfc26F(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "#FFC26F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 36.5872C16 25.2172 25.2172 16 36.5872 16H63.4128C74.7828 16 84 25.2172 84 36.5872V63.4128C84 74.7828 74.7828 84 63.4128 84H36.5872C25.2172 84 16 74.7828 16 63.4128V36.5872ZM36.5872 22.2385C28.6626 22.2385 22.2385 28.6626 22.2385 36.5872V63.4128C22.2385 71.3374 28.6626 77.7615 36.5872 77.7615H63.4128C71.3374 77.7615 77.7615 71.3374 77.7615 63.4128V36.5872C77.7615 28.6626 71.3374 22.2385 63.4128 22.2385H36.5872ZM50 62.1651C56.7187 62.1651 62.1652 56.7186 62.1652 50C62.1652 43.2814 56.7187 37.8349 50 37.8349C43.2814 37.8349 37.8349 43.2814 37.8349 50C37.8349 56.7186 43.2814 62.1651 50 62.1651ZM50 68.4037C60.1641 68.4037 68.4037 60.1641 68.4037 50C68.4037 39.8359 60.1641 31.5963 50 31.5963C39.836 31.5963 31.5964 39.8359 31.5964 50C31.5964 60.1641 39.836 68.4037 50 68.4037ZM67.7798 35.3394C69.5025 35.3394 70.8991 33.9429 70.8991 32.2202C70.8991 30.4975 69.5025 29.1009 67.7798 29.1009C66.0571 29.1009 64.6605 30.4975 64.6605 32.2202C64.6605 33.9429 66.0571 35.3394 67.7798 35.3394Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaLogoRFfc26F);
export default __webpack_public_path__ + "static/media/insta_logo_r__FFC26F.281a61a05e09a8409883cf9778e16ecf.svg";
export { ForwardRef as ReactComponent };